import { Permission } from '@/@types/permission';
import { getUserRoleAvailablePages } from './getUserRoleAvailablePages';

export type UserDefaultRouteUser = {
  is_admin: boolean;
  role?: {
    permissions?: Permission[] | null;
  } | null;
};

export function getUserDefaultRoute(
  user?: UserDefaultRouteUser
): string | null {
  if (!user) return null;

  const availablePages = getUserRoleAvailablePages(
    user.role?.permissions ?? []
  );

  if (user.is_admin || availablePages.includes('dashboard')) {
    return '/dashboard';
  }

  const firstAvailablePage = availablePages[0];

  return firstAvailablePage ? `/${firstAvailablePage}` : null;
}
